var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCornerResize = function SvgCornerResize(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15H10L15 10V7.5L7.5 15Z",
    fill: "#C6C9D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 15H3L15 3V0.5L0.5 15Z",
    fill: "#C6C9D1"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCornerResize);
export { ForwardRef as ReactComponent };